import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type FlowStepsProps = {
  steps: string[];
  align?: 'center' | 'start';
  className?: string;
};
export function FlowSteps({
  steps,
  align = 'center',
  className = ''
}: FlowStepsProps) {
  return <ol className={`flex flex-wrap items-center gap-x-2 gap-y-1.5 font-display text-base font-bold uppercase tracking-wide text-accent-400 md:text-lg ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} data-id="element-32" data-mp="270e5e2xnkoll">
      {steps.map((step, i) => <li key={step} className="flex items-center gap-2" data-id="element-33" data-mp="34mv0d1iwyq46" data-mpi={i}>
          {step}
          {i < steps.length - 1 && <ArrowRightIcon className="h-4 w-4 text-accent-600" aria-hidden="true" data-id="element-34" data-mp="2py79h8k0j4kk" />}
        </li>)}
    </ol>;
}